<template>
  <div>
    <div class="choice-container">

      <div class="choice-title">营销目标（随心推）

 

      </div>
      <div class="target-choice">
        <div>
          <div @click="marketing_goal_new = 'VIDEO_PROM_GOODS'"
            :class="marketing_goal_new == 'VIDEO_PROM_GOODS'?'card card-create-choice cardChosen':'card card-create-choice cardUnchosen'"
            style="height: 80px">
            <div class="left-part">
              <img
                src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/a26625dc6f61c97ec36efb296f568b8e.svg~tplv-55ejei7tpt-image.image"
                alt="" class="image" />
            </div>
            <div class="right-part">
              <div class="header">短视频/图文带货</div>
              <div class="content">吸引用户直接购买商品</div>
            </div>
          </div>
        </div>
        <div>
          <div @click="marketing_goal_new = 'LIVE_PROM_GOODS'"
            :class="marketing_goal_new == 'LIVE_PROM_GOODS' ? 'card card-create-choice cardChosen' : 'card card-create-choice cardUnchosen'"
            style="height: 80px">
            <div class="left-part">
              <img
                src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/64418bd14e919ec25c7f4c858d2433ab.svg~tplv-55ejei7tpt-image.image"
                alt="" class="image" />
            </div>
            <div class="right-part">
              <div class="header">直播带货</div>
              <div class="content">吸引用户进入直播间</div>
            </div>
          </div>
        </div>
      </div>



      <CreateVideo v-if="marketing_goal_new == 'VIDEO_PROM_GOODS'" :select_video_info_new="select_video_info_new"/>
      <CreateLive v-if="marketing_goal_new == 'LIVE_PROM_GOODS'" :select_video_info_new="select_video_info_new"/>


    </div>

  </div>

</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import createVideo from './components/createVideo.vue';
import createLive from './components/createLive.vue';
export default {
  name: 'batchCreatePlan',
  props: {
    marketing_goal: {
      type: String,
      default: 'VIDEO_PROM_GOODS',
    },
    select_video_info: {
      type:  Array
    },
  },
  data() {
    return {
      marketing_goal_new:this.marketing_goal,
      select_video_info_new:this.select_video_info,
    };
  },

  components: {
    CreateVideo: createVideo,
    CreateLive: createLive
  },

  watch: {
  }, 
  methods: {
  },
};
</script>


<style lang="less" scoped>
.choice-container {
  padding-left: 20px;
}

.choice-title {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 16px;
  margin-top: 15px;
  text-align: left;
}

.cardChosen {
  background: #fff;
  border: 1px solid #1890ff;
  border-radius: 3px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .1);
  box-sizing: border-box;
  cursor: pointer;
}

.card-create-choice {
  display: flex;
  flex-direction: row;
  height: 144px;
  padding: 18px 24px;
  position: relative;
  width: 272px;
}

.card-create-choice .left-part {
  margin-right: 12px;
}

.card-create-choice .right-part {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.card-create-choice .right-part .header {
  color: #333;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.card-create-choice .right-part .content {
  color: rgba(0, 0, 0, .4);
  font-size: 12px;
  line-height: 17px;
  margin-top: 8px;
}

.cardUnchosen {
  background-color: #f2f2f2;
  border: 1px solid transparent;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
}

.choice-container .target-choice {
  column-gap: 16px;
  display: grid;
  grid-template-columns: 272px 272px;
}

.cardUnchosen:hover {
  background-color: #edf1fd
}
</style>
